export const searchSchema = {
    title: 'search',
    version: 0,
    description: 'AMB searches',
    type: 'object',
    primaryKey: 'id',
    properties: {
        id: {
            type: 'string',
        },
        createdAt: {
            type: 'number',
        },
        label: {
            type: 'string',
        },
        coords: {
            type: 'object',
            properties: {
                lat: {
                    type: 'number',
                },
                lng: {
                    type: 'number',
                },
            },
        },
    },
};
